module.exports = __webpack_public_path__ + "img/email-header-introspection@2x.31334676.png";